import { render, staticRenderFns } from "./ManageSendValidation.vue?vue&type=template&id=79b98b22&scoped=true"
import script from "./ManageSendValidation.vue?vue&type=script&lang=js"
export * from "./ManageSendValidation.vue?vue&type=script&lang=js"
import style0 from "./ManageSendValidation.vue?vue&type=style&index=0&id=79b98b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b98b22",
  null
  
)

export default component.exports